import { render, staticRenderFns } from "./NewEquipment.vue?vue&type=template&id=2c2db0ec&scoped=true&"
import script from "./NewEquipment.vue?vue&type=script&lang=js&"
export * from "./NewEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2db0ec",
  null
  
)

export default component.exports